import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const STRATEGICCOMMERCIALZONE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StrategicCommercialZone.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('remsoftName', 'Entity.StrategicCommercialZone.RemsoftName')
    .maxLength(200)
    .build(),
];

export const STRATEGICCOMMERCIALZONE_CONFIG = {
  entityName: 'StrategicCommercialZone',
  localizationKey: 'Planning::Entity.StrategicCommercialZone',
  fields: STRATEGICCOMMERCIALZONE_FIELDS,
  permission: 'PlanningLocation.StrategicCommercialZones',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
